﻿
import {Injectable} from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpResponse, HttpRequest } from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {map} from "rxjs/operators";
import { environment } from '../../../environments/environment';
import { ContextService } from './context-service';
import { ContextInfo } from "../../@shared/models/context-info";
import { SpinnerService } from "./spinner-service";
import { LoggerService } from "./logger-service";
import { TokenUtilsService } from "./token-utils-service";

@Injectable()
export class ProxyInterceptorService implements HttpInterceptor {

    constructor(
        private contextService: ContextService,
        private spinnerService: SpinnerService,
        private loggerService: LoggerService,
        private tokenUtilsService: TokenUtilsService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const excludedUrls = ['LoginWithEmail', 'LoginWithAccessToken', 'loginsettings'];
        const isAuthEndpoint = excludedUrls.some(endpoint => req.url.includes(endpoint));
    
        if (isAuthEndpoint) {
            return next.handle(req).pipe(
                map(event => {
                    if (event instanceof HttpResponse) {
                        this.loggerService.logData(event);
                    }
                    return event;
                })
            );
        }
    
        const token = req.headers.get('Authorization');
        if (!token) {
            return next.handle(req).pipe(
                map(event => {
                    if (event instanceof HttpResponse) {
                        this.loggerService.logData(event);
                    }
                    return event;
                })
            );
        }
    
        if (this.tokenUtilsService.isFulfillerToken(token)) {
            return next.handle(req).pipe(
                map(event => {
                    if (event instanceof HttpResponse) {
                        this.loggerService.logData(event);
                    }
                    return event;
                })
            );
        }
    
        this.loggerService.logException({
            message: 'Invalid token',
            token
        });
        
        return throwError(new Error('Invalid auth token — request cancelled'));
    }
}